<template>
  <div>
    <div class="admin_topbar">
      <div class="admin_topbar_mainblock">
        <h1 class="header">Проекты</h1>
        <div class="filters">
          <label>
            <input
              type="checkbox"
              class="checkbox"
              v-model="projectsFilter.work"
            />
            <span class="green-text"> В работе </span>
          </label>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              v-model="projectsFilter.develop"
            />
            <span class="purple-text">Планирование</span>
          </label>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              v-model="projectsFilter.finished"
            />
            <span class="violet-text">Завершённые</span>
          </label>
          <label>
            <input
              type="checkbox"
              class="checkbox"
              v-model="projectsFilter.archived"
            />
            <span class="orange-text">Архивные</span>
          </label>
          <a class="button1" title="Добавить проект" @click="addProject">
            Добавить проект</a
          >
        </div>
      </div>
    </div>
    <div class="view">
      <table>
        <th>Название</th>
        <th>Контрагент</th>
        <th>Статус</th>
        <th>Дата начала</th>
        <th>Дата окончания</th>
        <th>Действия</th>
        <tr
          v-for="project in filteredProjects"
          :key="project.id"
          class="projects-entry"
          :class="project.status"
          @click="
            goToProject(project.id, project.name, project.status, project.edit)
          "
        >
          <td v-if="project.edit">
            <input type="text" v-model="project.name" />
          </td>
          <td v-else>{{ project.name }}</td>

          <td v-if="project.edit">
            <select v-model="project.contractor">
              <option
                v-for="contractor in contractors"
                :key="contractor.id"
                :value="contractor"
              >
                {{ contractor.name }}
              </option>
            </select>
          </td>
          <td v-else>{{ project.contractor.name }}</td>

          <td v-if="project.edit">
            <select v-model="project.status">
              <option value="develop">Планирование</option>
              <option value="work">В работе</option>
              <option value="finished">Завершён</option>
            </select>
          </td>
          <td v-else v-text="getStatusText(project.status)"></td>

          <td v-if="project.edit">
            <input type="date" v-model="project.start" />
          </td>
          <td v-else>{{ new Date(project.start).toLocaleDateString() }}</td>

          <td v-if="project.edit">
            <input type="date" v-model="project.finish" />
          </td>
          <td v-else>{{ new Date(project.finish).toLocaleDateString() }}</td>

          <td @click.stop="handleControl" class="row-control-buttons">
            <div class="verticaldots__wrapper">
              <VerticalDots></VerticalDots>
              <div class="dots_menu">
                <p
                  class="dots_menu__item"
                  v-if="project.edit"
                  @click.stop="handleEdit(project)"
                >
                  <AddIcon></AddIcon> Сохранить
                </p>
                <p
                  class="dots_menu__item"
                  v-if="!project.edit"
                  @click.stop="handleEdit(project)"
                >
                  <EditIcon></EditIcon> Редактировать
                </p>
                <p
                  class="dots_menu__item"
                  v-if="project.status !== 'archived'"
                  @click.stop="handleDelete(project)"
                >
                  <DeleteIcon></DeleteIcon> Удалить
                </p>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import VerticalDots from "../components/Icons/VerticalDots";
import EditIcon from "../components/Icons/EditIcon";
import DeleteIcon from "../components/Icons/DeleteIcon";
import AddIcon from "../components/Icons/AddIcon";
import axios from "axios";

export default {
  async mounted() {
    this.initProjects();
  },
  components: {
    AddIcon,
    VerticalDots,
    EditIcon,
    DeleteIcon,
  },
  data: () => {
    return {
      lastId: 4,
      projectsFilter: {
        develop: true,
        work: true,
        finished: false,
        archived: false,
      },
      contractors: [],
      projects: [],
    };
  },
  computed: {
    filteredProjects() {
      return this.projects.filter((i) => this.projectsFilter[i.status]);
    },
  },
  watch: {
    projectsFilter: {
      handler() {
        localStorage.setItem(
          "projectsFilter",
          JSON.stringify(this.projectsFilter)
        );
        setTimeout(() => {
          let elems = document.querySelectorAll("select");
          M.FormSelect.init(elems, {});
        }, 0);
      },
      deep: true,
    },
  },
  methods: {
    goToProject(id, name, status, edit) {
      if (status != "archived" && !edit) {
        this.$store.commit("setProjectName", name);
        setTimeout(
          () =>
            this.$router.push({ name: "Estimate", params: { projectId: id } }),
          0
        );
      }
    },
    handleControl(e) {
      document.querySelectorAll(".dots_menu").forEach((el) => {
        if (el !== e.currentTarget.querySelector(".dots_menu")) {
          el.style.display = "none";
        }
      });
      if (
        e.currentTarget.querySelector(".dots_menu").style.display === "none"
      ) {
        e.currentTarget
          .querySelector(".dots_menu")
          .style.setProperty("display", "flex");
      } else {
        e.currentTarget
          .querySelector(".dots_menu")
          .style.setProperty("display", "none");
      }
    },
    addProject() {
      this.projects.unshift({ status: "develop", contractor: {}, edit: true });
      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        M.FormSelect.init(elems, {});
      }, 0);
    },
    handleEdit(project) {
      if (project.edit) {
        this.setProject(project);
      }
      project.edit = !project.edit;
      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        M.FormSelect.init(elems, {});
      }, 0);
      document.querySelectorAll(".dots_menu").forEach((el) => {
        el.style.display = "none";
      });
    },
    handleDelete(project) {
      project.status = "archived";
      this.setProject(project);
      document.querySelectorAll(".dots_menu").forEach((el) => {
        el.style.display = "none";
      });
    },
    getStatusText(status) {
      switch (status) {
        case "develop":
          return "Планирование";
        case "work":
          return "В работе";
        case "finished":
          return "Завершён";
        case "archived":
          return "В архиве";
      }
    },
    async initProjects() {
      const self = this;
      if (localStorage.getItem("projectsFilter")) {
        this.projectsFilter = JSON.parse(
          localStorage.getItem("projectsFilter")
        );
      }

      axios
        .post(
          "/backend/contractors.php",
          {
            action: "getContractorsLight",
          },
          {
            headers: {
              "Content-Type": "application/json",
              authorization: localStorage.getItem("isLogged"),
            },
          }
        )
        .then((response) => {
          self.contractors = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });

      axios
        .post(
          "/backend/projects.php",
          {
            action: "getProjects",
          },
          {
            headers: {
              "Content-Type": "application/json",
              authorization: localStorage.getItem("isLogged"),
            },
          }
        )
        .then((response) => {
          self.projects = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    async setProject(project) {
      const resp = await fetch("/backend/projects.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "setProject",
          project,
        }),
      });
      const id = await resp.text();
      if (id != 0) {
        project.id = id;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.white-space {
  width: calc(100% - 130px);
  height: 60px;
  position: fixed;
  background-color: #fff;
  z-index: 2;
  top: 0;
  left: 130px;
}
.projects-entry:hover {
  background-color: #eee;
}

.projects-entry {
  cursor: pointer;

  &.develop td:nth-of-type(3) {
    color: #9c27b0;
    font-weight: bold;
  }

  &.work td:nth-of-type(3) {
    color: #14A38B;
    font-weight: bold;
  }

  &.finished td:nth-of-type(3) {
    color: #9E9E9E;
    font-weight: bold;
  }

  &.archived td:nth-of-type(3) {
    color: #F0783B;
    font-weight: bold;
  }

  &.deleted td:nth-of-type(3) {
    color: #F44336;
    font-weight: bold;
  }
}

.row-control-buttons {
  width: 90px;
}

.table-button {
  border: 1px solid silver;
  cursor: pointer;
  color: #000000DE;
}
#view table tr > td:nth-child(2) {
  color: #95939B;
}
#view table tr > td:nth-child(4),#view table tr > td:nth-child(5) {
  color: #2C2738;
  opacity: 0.5;
}
</style>
